/* WellGroomed: defensive fallback for product media zoom.
   Dawn's native modal-opener remains primary; this only acts if it fails. */
document.addEventListener('click', function (event) {
  const toggle = event.target.closest('modal-opener .product__media-toggle, modal-opener .product__media-icon');
  if (!toggle) return;
  const opener = toggle.closest('modal-opener');
  if (!opener) return;
  const selector = opener.getAttribute('data-modal');
  if (!selector) return;
  window.setTimeout(function () {
    const modal = document.querySelector(selector);
    if (!modal || modal.hasAttribute('open')) return;
    const button = opener.querySelector('.product__media-toggle[data-media-id]');
    if (typeof modal.show === 'function' && button) modal.show(button);
  }, 120);
}, true);
